import '@/app/routeComponentHooks'
import { API } from '@/api/API'
import { createVueApp } from '@/app/vueApp'
import { authExternal } from '@/helpers/AuthExternal'
import { configCatRequest, initializeFlags } from '@/helpers/ConfigCat'
import { defaultLanguage } from '@/helpers/Environment'
import { preloadPromoCodes } from '@/helpers/PreloadPromoCodes'
import { initializeTrackJS } from '@/helpers/TrackJS'
import { initializeStores } from '@/state/Initialization'
import store from '@/store/store'

import { setLocale } from './TixTime/helpers'

initializeTrackJS()

if (window.Cypress && window.__mockStripeMethods && window.Stripe) {
  const origStripe = window.Stripe
  window.Stripe = (...args) => {
    return {
      ...origStripe(...args),
      ...window.__mockStripeMethods,
    }
  }
}

setLocale(defaultLanguage)

// Do not wait for the flags to initialize.
// noinspection JSIgnoredPromiseFromCall
initializeFlags()

if (!authExternal.isExternalAuth()) {
  initializeStores()
} else {
  configCatRequest.then(async ({ auth0_session_revocation }) => {
    if (!auth0_session_revocation) {
      initializeStores()
      return
    }

    if (await authExternal.isSessionRevoked()) {
      await API.post('logout')
      await store.dispatch('clearAll')
    } else {
      initializeStores()
    }

    document.addEventListener('visibilitychange', async () => {
      if (document.visibilityState === 'visible' && (await authExternal.isSessionRevoked())) {
        await API.post('logout')
        await store.dispatch('clearAll')
      }
    })
  })
}

const urlSearchParams = new URLSearchParams(window.location.search)
window.tixAppState = {
  queryParams: Object.fromEntries(urlSearchParams.entries()),
}

// Consume discount codes injected with the `code` query string parameter or cookie.
preloadPromoCodes()

const app = createVueApp()

// Expose app to Cypress for test cases.
if (window.Cypress) {
  window['vueApp'] = app
}

export default app
